import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperItem, FormWrapperInputComponent,
} from "../../../common/component/Index";
import DEFINE, { HOTEL, PATHS, UPLOAD_DIRECTORY, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import { isEqual, get, cloneDeep, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Post from '../../../../../models/Post';
import Wrapper from './../../../common/component/Wrapper';

import './PostDetail.less';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import RichTextEditor, { ClassicEditor } from "../../../common/component/RichTextEditor";
import { message, Select } from "antd";
import i18n from "../../../../../constants/initLng";
import Switch from "../../../common/component/Switch";
import UploadImage from "../../../common/component/UploadImage";
import TranslateButton from '../../../common/component/TranslateButton';

let permisionActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    isSubmit: false,
    isGetItem: false,
    isUpload: {
        isUpload: false,
        type: ""
    },
    validation: {},
    typeUpload: "",
};

export default class PostDetail extends Component {
    constructor(props) {
        super(props);
        const isUpdate = props.match && props.match.params && props.match.params.id;
        this.state = {
            ...defaultState,
            action: isUpdate ? DETAIL_ACTIONS.UPDATE : DETAIL_ACTIONS.CREATE,
            post: this.props.postState.detail.post,
            uploadFiles: [],
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    initDetail() {
        const { match, postState } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            const post = find(postState.posts, h => h.id === id);
            // if(page) this.setState({page});
            this.props.getPostDetail(id);
        }
        this.props.getListAllCategories();
    }

    componentWillUnmount() {
        this.props.setPostDetail(new Post())
    }

    processUploadedFiles(fileObj) {
        let uploadFiles = this.state.uploadFiles;
        const post = this.state.post;
        if (this.state.typeUpload === "thumbImage") {
            post.setImage(get(fileObj, 'data.fileUrl'), get(fileObj, 'data.fileName'));
        } else if (this.state.typeUpload === "headerImage") {
            post.setImageHeader(get(fileObj, 'data.fileUrl'), get(fileObj, 'data.fileName'))
        }
        this.setState({ post, uploadFiles, typeUpload: "" });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.postState.detail.post && !isEqual(nextProps.postState.detail.post, this.props.postState.detail.post)) {
            this.setState({
                post: nextProps.postState.detail.post,
                action: nextProps.postState.detail.post.id ? DETAIL_ACTIONS.UPDATE : this.state.action
            });
        }
        if (nextProps.uploadState.file && !isEqual(nextProps.uploadState.file, this.props.uploadState.file)) {
            this.processUploadedFiles(nextProps.uploadState.file);
        }
    }

    render() {
        const { t, uploadState, postState, categoryState } = this.props;
        const { isFetching } = postState;
        const { action, isSubmit, isGetItem, validation, post, typeUpload } = this.state;
        return (
            <LoadingComponent spinning={isFetching || isSubmit}>
                <PageListComponent className="post-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'posts'}
                        titleHeader={action === "CREATE"
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.post.title_page')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.post.title_page')}`.toLowerCase()))
                        }
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={post.translations}
                                current={post.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChange('languageCode', language.code)}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={isGetItem}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        submitButtonRight={true}
                    >
                        <Wrapper className='col-md-12 basic-section'>
                            <FormWrapperItem>
                                <Wrapper className="col-md-4">
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.post.thumbImageView`)}
                                    >
                                        <UploadImage
                                            multiple={false}
                                            loading={typeUpload === "thumbImage" ? uploadState.isFetchingMultiple : false}
                                            thumbnailSize={'100%'}
                                            thumbnailStyle={{ maxHeight: 200 }}
                                            buttonSize={150}
                                            uploadText={t('item.popularPlace.uploadFile')}
                                            loadingText={t('item.popularPlace.uploading')}
                                            onChange={(e) => this.onUploadImages(e, 'thumbImage')}
                                            onRemoveThumbnail={(e) => this.removeImages(e, 'thumbImage')}
                                            thumbnails={post.thumbImage && this.getThumbSources([post.thumbImage])} />
                                    </FormWrapperInputComponent>
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.post.headerImageView`)}
                                    >
                                        <UploadImage
                                            multiple={false}
                                            loading={typeUpload === "headerImage" ? uploadState.isFetchingMultiple : false}
                                            thumbnailSize={'100%'}
                                            thumbnailStyle={{ maxHeight: 200 }}
                                            buttonSize={150}
                                            uploadText={t('item.popularPlace.uploadFile')}
                                            loadingText={t('item.popularPlace.uploading')}
                                            onChange={(e) => this.onUploadImages(e, 'headerImage')}
                                            onRemoveThumbnail={(e) => this.removeImageHeader(e, 'headerImage')}
                                            thumbnails={post.headerImage && this.getThumbSources([post.headerImage])} />
                                    </FormWrapperInputComponent>
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.post.source`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Select className="select-category select-source"
                                            showArrow
                                            placeholder={t(`item.post.source`)}
                                            style={{ width: '100%' }}
                                            value={post.source}
                                            onChange={source => this.onChange('source', source)}
                                        >
                                            <Select.Option key="vpt" value="vpt">
                                                Vinpearl Travel
                                            </Select.Option>
                                            <Select.Option key="vpg" value="vpg">
                                                Vinpearl Golf
                                            </Select.Option>
                                        </Select>
                                    </FormWrapperInputComponent>
                                </Wrapper>
                                <Wrapper className="col-md-8">
                                    <Wrapper className="row">
                                        <Wrapper className="col-md-12">
                                            <FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={post.title}
                                                validation={validation.title}
                                                labelTitle={t(`item.post.title`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`title`}
                                                    onChange={(e) => this.onChange('title', e.target.value)}
                                                    value={checkUndefine(post.title)} />
                                            </FormWrapperInputComponent>
                                        </Wrapper>
                                        <Wrapper className="col-md-10">
                                            <FormWrapperInputComponent
                                                labelTitle={t(`item.post.categories`)}
                                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                            >
                                                <Select className="select-category"
                                                    showArrow
                                                    mode="multiple"
                                                    placeholder={t(`item.post.categories`)}
                                                    value={post.categoryIds}
                                                    onChange={categories => this.onChange('categoryIds', categories)}
                                                    style={{ width: '100%' }}
                                                >
                                                    {categoryState.listCategories && categoryState.listCategories.map((category, k) => (
                                                        <Select.Option key={k} value={category.id}>
                                                            {category.name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </FormWrapperInputComponent>
                                        </Wrapper>
                                        <Wrapper className="col-md-2">
                                            <FormWrapperInputComponent
                                                labelTitle={t(`item.post.order`)}
                                            >
                                                <Input placeholder="" type={`number`}
                                                    className={`form-control`}
                                                    name={`order`} onChange={(e) => this.onChange('order', e.target.value)}
                                                    value={post.order} />
                                            </FormWrapperInputComponent>
                                        </Wrapper>
                                    </Wrapper>
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.post.description`)}
                                    >
                                        <RichTextEditor
                                            editor={ClassicEditor}
                                            config={{ uploadDirectory: UPLOAD_DIRECTORY.POST }}
                                            data={checkUndefine(post.description)}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                return this.onChange("description", data)
                                            }}
                                        />
                                    </FormWrapperInputComponent>
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.post.content`)}
                                    >
                                        <RichTextEditor
                                            editor={ClassicEditor}
                                            config={{ uploadDirectory: UPLOAD_DIRECTORY.POST }}
                                            data={checkUndefine(post.content)}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                return this.onChange("content", data)
                                            }}
                                        />
                                    </FormWrapperInputComponent>
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.post.isAvailable`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <br />
                                        <Switch checked={post.isAvailable}
                                            onChange={(value, e) => this.onChange('isAvailable', value)}
                                            name={`isAvailable`} disabled={isSubmit} />
                                    </FormWrapperInputComponent>
                                </Wrapper>
                            </FormWrapperItem>
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    getThumbSources(thumbs) {
        return (thumbs || []).filter(t => t && Object.keys(t).length > 0).map(t => `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t.url}`)
    }

    onUploadImages = (file, type) => {
        this.setState({
            typeUpload: type,
        });
        let fileData = file.target.files;
        let uploadFiles = this.state.uploadFiles;
        if (fileData.length > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        } else if ((uploadFiles.length + fileData.length) > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        }
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        Object.keys(fileData).map((i) => {
            if (imageValidation.includes(fileData[i].type)) {
                this.props.onUploadFile({ file: fileData[i], directory: UPLOAD_DIRECTORY.POST, isFile: 2 })
            } else {
                message.error(i18n.t('validation.image'))
            }
        })
    };

    removeImages = (i, k) => {
        if (!i) return;
        const post = this.state.post;
        post.removeImage(i);
        this.setState({ post });
    };

    removeImageHeader = (i, k) => {
        if (!i) return;
        const post = this.state.post;
        post.removeImageHeader(i);
        this.setState({ post });
    };

    onChange = (fieldName, value) => {
        const post = this.state.post;
        if (Array.isArray(value)) {
            post[fieldName] = value
        } else if (fieldName === 'isAvailable') {
            post[fieldName] = value
        } else {
            post[fieldName] = value.trimLeft();
        }
        this.setState({ post });
    };

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.POST.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { post } = this.state;
        post.setTranslate(language.code);
        post.setData();
        this.setState({ post, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const post = cloneDeep(this.state.post);
        const action = DETAIL_ACTIONS[post.id ? 'UPDATE' : 'CREATE'];
        post.setTranslate(undefined, true);
        post.setData();
        this.setState({ post, action });
    }

    onSaveTranslate = () => {
        const { post } = this.state;
        const translateFunction = post.translate.id ? this.props.updatePostTranslate : this.props.createPostTranslate;
        translateFunction(post, post.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { post } = this.state;
        post.setTranslate(language.code);
        this.props.deletePostTranslate(post, { id: post.id });
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { post, action } = this.state;
        if (this.validate()) {
            if (!post.thumbImage) {
                message.error(Func.formatValidation(i18n.t('validation.statusCode.code.12'), 1));
                return false;
            }
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createPostDetail(post)
            } else {
                this.props.updatePostDetail({ post, props: this.props })
            }
        }
    };

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                title: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.post.title`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.post, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }
}
